import logger from '../../utils/logger';

/**
 * Auto cut off adjustment
 *
 * @param batchStore
 * @param primaryBin
 * @param {WeighedDataToBatch} weighedData
 * @param {BatchData} batchData
 */
export const autoCutOffAdjust = (batchStore, primaryBin, weighedData, batchData) => {
  if (!primaryBin.autoCutOff || !primaryBin.autoCutOffAdjustment || primaryBin.autoTuning) {
    return;
  }

  const { scale, material, materialDetails, mft } = weighedData;

  batchStore.getScaleWeightAfterSettlingTime(scale, materialDetails.scaleSettlingTime, currentWeight => {
    const s = batchStore.getDeviceStatus(primaryBin.id);
    const weight = currentWeight - s.prevWeight;
    const tolerance = batchStore.getTolerance(materialDetails, mft);
    const isSmallLoadSize = batchStore.isSmallLoadSize(batchData);
    const freeFall = batchStore.getFreeFall(primaryBin, batchData);
    const isUnderTarget = weight + tolerance?.under < mft;
    const isOverTarget = weight - tolerance?.over > mft;

    logger.log('autoCutOff::', material.code, primaryBin.description, s.prevWeight, weight, mft,
      'tolerance', tolerance, 'isUnder:', isUnderTarget, 'isOver:', isOverTarget);

    if (isUnderTarget || isOverTarget) {
      let changedData;

      if (isSmallLoadSize) {
        changedData = {
          smallFreeFall: isUnderTarget
            ? freeFall - primaryBin.autoCutOffAdjustment
            : freeFall + primaryBin.autoCutOffAdjustment,
        };
      } else {
        changedData = {
          freeFall: isUnderTarget
            ? freeFall - primaryBin.autoCutOffAdjustment
            : freeFall + primaryBin.autoCutOffAdjustment,
        };
      }

      logger.log('autoCutOff::', material.code, primaryBin.description,
        weight, 'tolerance', tolerance,
        'isSmallLoadSize', isSmallLoadSize, isSmallLoadSize
          ? `smallFreeFall ${primaryBin.smallFreeFall} -> ${changedData.smallFreeFall}`
          : `freeFall ${primaryBin.freeFall} -> ${changedData.freeFall}`);

      if (!batchStore.isDemo && !batchStore.replayMode && !batchStore.isTestMode) {
        batchStore.devicesStore.updateDevice(primaryBin.id, primaryBin.deviceTypeName, {
          ...primaryBin,
          ...changedData,
        });
      }
    }
  });
};
